<script>
import VJstree from 'vue-jstree'
import MediaDirectoryActions from "./MediaDirectoryActions";

export default {
        components: {
            MediaDirectoryActions,
            VJstree
        },
        props: {
            seeDirectoryActions: Boolean,
            filter: {
              type: Object,
              default() {
                return {};
              }
            },
            refreshPage: {
              type: Boolean,
              default: () => true
            },
        },
        data() {
            return {
                loading: true,
                tree: {},
                uri: URI(window.location.href),
                selected: [],
                asyncData: [],
                loadData: function (oriNode, resolve) {
                    if (_.isArray(oriNode.data)) {
                        resolve(this.filterNodes(this.tree.children, []));
                    } else {
                        let path = oriNode.data.index.join('.children.');
                        let node = _.get(this.tree.children, path);

                        resolve(this.filterNodes(node.children, oriNode.data.index));
                    }
                }.bind(this)
            }
        },
        mounted() {
            this.fetchDirectories();
            this.getSelected();
        },
        methods: {
            fetchDirectories() {
                this.loading = true;
                axios.get('/mediaserver/directory').then((response) => {
                    this.tree = response.data;
                    this.loading = false;

                    this.$nextTick(() => {
                        this.openSelectedChildNode(this.$refs.tree.data);
                    });
                });
            },
            getSelected() {
                let parameters = this.filter;
                this.selected.push(JSON.stringify({index: parameters.index, directory: parameters.directory || ''}));
            },
            filterNodes(nodes, parentIndex) {
                return _.map(nodes, (node, i) => {
                    let index = _.clone(parentIndex);
                    index.push(i);

                    return {
                        'key': node.value,
                        'label': node.label,
                        'value': node.value,
                        'index': index,
                        'icon': 'fa fa-folder-o',
                        'isLeaf': node.children.length === 0,
                        'selected': this.nodesToOpen.length > 0 && node.value == _.last(this.nodesToOpen),
                    };
                });
            },
            nodeSelected(node) {
                if (!this.refreshPage) {
                    this.$emit('nodeSelected', JSON.parse(node.data.value));

                    return;
                }

                this.uri.removeQuery('page');

                _.forEach(JSON.parse(node.data.value), (value, key) => {
                    this.uri.removeQuery(key);

                    if (value) {
                        this.uri.addQuery(key, value);
                    }
                });

                window.location.href = this.uri.toString();
            },
            openSelectedChildNode(nodes) {
                this.$nextTick(() => {
                    let node = _.head(_.filter(nodes, (node) => {
                        return _.indexOf(this.nodesToOpen, node.value) !== -1;
                    }));

                    if (node && node.children.length > 0) {
                        node.opened = true;

                        if (_.map(node.children, 'children').length > 0) {
                            this.openSelectedChildNode(node.children);
                        }
                    }
                });
            }
        },
        computed: {
            nodesToOpen() {
                let nodes = [];
                let index = this.filter.index;
                let directory = this.filter.directory;

                if (index) {
                    if (!directory) {
                        nodes.push(JSON.stringify({
                            index: index,
                            directory: '',
                        }));
                    } else {
                        let directories = directory.split('::');

                        for (let i = 1; i <= directories.length; i++) {
                            nodes.push(JSON.stringify({
                                index: index,
                                directory: _.take(directories, i).join('::'),
                            }));
                        }
                    }
                }

                return nodes;
            }
        },
    }
</script>

<template>
    <div>
        <div v-if="loading" class="text-center p-m">
            <span>Loading</span>
            <i class="fa fa-cog fa-spin"></i>
        </div>
        <div v-else>
            <media-directory-actions
                :tree="tree"
                :selected="selected"
                v-if="seeDirectoryActions"
            ></media-directory-actions>

            <v-jstree
                text-field-name="label"
                :allow-transition="false"
                :data="asyncData"
                :async="loadData"
                @item-click="nodeSelected"
                ref="tree"
            />
        </div>
    </div>
</template>
